// Copyright (c) 2018 Deere & Company

import MassProcessInvoiceContainer from '../../../claim/dealer-invoices/components/mass-process-invoice/index';

export default {
    component: MassProcessInvoiceContainer,
    name: 'INVOICE_REQUEST',
    path: 'mass-process-invoice/:invoiceRequestNumber'
};



// WEBPACK FOOTER //
// ./src/routes/claims/invoice-details/mass-process-invoice.js